const driveCardHandle = () => import('@/pages/driveCardHandle/index')
const driveCardHandleDetail = () => import('@/pages/driveCardHandle/detail/index')
const driveCardHandleReg = () => import('@/pages/driveCardHandle/pending/index')
const recordDetail = () => import('@/pages/driveCardHandle/detail/recordDetail')
const recordDetailList = () => import('@/pages/driveCardHandle/detail/recordDetailList')
const moreHandle = () => import('@/pages/driveCardHandle/moreHandle')
const OCRIndex = () => import('@/pages/driveCardHandle/OCR/index')

export default [
  {
    path: '/driveCardHandle',
    name: 'driveCardHandle',
    component: driveCardHandle,
    meta: {
      storeKey: 'mtc.renewal.drive.new'
    }
  },
  {
    path: '/driveCardHandleDetail',
    name: 'driveCardHandleDetail',
    component: driveCardHandleDetail,
    meta: {
    }
  },
  {
    path: '/driveCardHandleReg',
    name: 'driveCardHandleReg',
    component: driveCardHandleReg,
    meta: {
    }
  },
  {
    path: '/driveCardHandleRecordDetail',
    name: 'driveCardHandleRecordDetail',
    component: recordDetail,
    meta: {
    }
  },
  {
    path: '/driveCardHandleDetailList',
    name: 'driveCardHandleDetailList',
    component: recordDetailList,
    meta: {
    }
  },
  {
    path: '/driveCardHandleHandle',
    name: 'driveCardHandleHandle',
    component: moreHandle,
    meta: {
    }
  },
  {
    path: '/OCRIndex',
    name: 'OCRIndex',
    component: OCRIndex,
    meta: {
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/driveCardHandle/index.js